import * as React from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/rootReducer';
import { Button, Typography } from '@material-ui/core';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import themeDark from "../components/shared/themeDark";
import { MuiThemeProvider, withStyles } from "@material-ui/core/styles";
import { showNavbar } from '../store/modules/appStateSlice';
import { IAppPropsWithRoute } from '../common/types';
import Paper from "@material-ui/core/Paper";
import Link from '@material-ui/core/Link';

import homeBackground from '../assets/images/home-background.jpg'
import icons from '../assets/images/home-icon.svg'
import homepageLogo from '../assets/images/homepage-logo.png'
import { consts } from '../common/consts';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import formatDistanceToNowStrict from 'date-fns/formatDistanceToNowStrict';

interface HomePageProps extends IAppPropsWithRoute {
};

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
    },
    container: {
        height: 'calc(100vh - 58px)', backgroundImage: `url(${homeBackground})`, backgroundColor: '#00152e',
        backgroundSize: '100%', backgroundRepeat: 'no-repeat', borderRadius: '0',
        overflowY:'auto'
    },
    bodyContainer: {
        height: '100%', margin: 'auto', width: '50%', maxWidth: 580, display: 'flex', flexDirection: 'column',
        justifyContent: 'flex-start', alignItems: 'center', textAlign: 'center',
    },
    logo: {
        width: 560, maxWidth: '100%', height: 'auto', margin: '75px 0px 25px 0px',
    },
    title: {
        fontFamily: 'Lato', fontWeight: 900, fontSize: 38,
    },
    button: {
        backgroundColor: '#F4B827', '&:hover': { backgroundColor: '#F4B827', }, margin: '40px 0px 25px 0px', fontWeight: 'bold',
    },
    divider: {
        width: 600, height: '1px', backgroundColor: '#D8D8D8', marginBottom: 25,
    },
    body: {
        display: 'flex', flexDirection: 'column', alignItems: 'center',
    },
    footer: {
        display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: 60, paddingBottom: 20,
    },
    link: {
        color: '#FFFFFF90', '&:hover': { color: '#FFFFFF', textDecoration: 'none' }, fontWeight:700,
    },
    subTitle: {
        fontFamily: 'Lato', fontWeight: 400, fontSize: 24, color: '#F4B827', margin: 0, marginBottom:20
    },
    subTitle2: {
        fontFamily: 'Lato', marginBottom:10,color: '#ffffffc4', 
    },

}));

function HomePage(props: HomePageProps): JSX.Element {
    const { authStore } = useSelector((state: RootState) => state);

    let lastLogin = authStore?.data?.lastLogin;
    try {
        if (lastLogin?.split(" ")[0].split("-")[2].length === 4) {
            lastLogin = `${lastLogin.split(" ")[0].split("-").reverse().join("-")} ${lastLogin.split(" ")[1]}`
        }
    } catch (err) {
        console.log(err);
    }

    const dispatch = useDispatch();
    const classes = useStyles();
    const [disableBooking, setdisableBooking] = React.useState(true);
    const [disablePCR, setdisablePCR] = React.useState(true);

    React.useEffect(() => {
        var permissions = authStore.data?.role.split(",");
            var perm = [consts.Permissions.SMAAdminViewSystemActivity , consts.Permissions.SMAAdminPatientTransportDashboard , consts.Permissions.SMAManageRequestCallout
                , consts.Permissions.SMADriver , consts.Permissions.SMAAdminManageUserprofiles , consts.Permissions.SMAAdminManageVehicles
                , consts.Permissions.SMAScheduleTransfer , consts.Permissions.SMAMakeBooking , consts.Permissions.SMAViewSchedule
                , consts.Permissions.SMARequestAdHocTransfer , consts.Permissions.SMAAdminManageLocations , consts.Permissions.SMAAdminManageReasonsForDelay
                , consts.Permissions.SMASubmitPatientCareRecords , consts.Permissions.SMAAdminManageCustomers , consts.Permissions.SMAAdminManageUsers
                , consts.Permissions.SMAAdminManageWards , consts.Permissions.SMASuperUser , consts.Permissions.SMAEditBooking
                , consts.Permissions.SMAViewTransferHistory , consts.Permissions.ViewCustomerTransferHistory , consts.Permissions.CustomerDriver
                , consts.Permissions.ManageCustomerVehicles , consts.Permissions.ScheduleTransfer , consts.Permissions.ViewDashboard
                , consts.Permissions.EditBooking , consts.Permissions.MakeBooking , consts.Permissions.ManageUserprofiles
                , consts.Permissions.SubmitPatientCareRecords , consts.Permissions.ViewSchedule , consts.Permissions.RequestAdHocTransfer
                , consts.Permissions.ManageUsers , consts.Permissions.RequestCallout,consts.Permissions.SMAViewPCR,consts.Permissions.ViewPCR 
                , "SMAVerifyNewDevice" , "SMAAccessNurseStation" , "SMAAllowMultipleActiveUserSessions"
                , "SMAAccessHQDisplay" , "AccessNurseStation" , "CancelTransfer"
                , "AllowMultipleActiveUserSessions" , "VerifyNewDevice"
            ]

        var permissions = permissions?.filter(permission => perm.includes(permission));
        if (permissions) {
            if (permissions.includes(consts.Permissions.RequestCallout)) {
                props.history.push('/requestcallout');
            }
            else {
                if (permissions.length > 0 && ((permissions.includes(consts.Permissions.SMAMakeBooking)) || (permissions.includes(consts.Permissions.MakeBooking)))) {
                    setdisableBooking(false);
                }
                if (permissions.length == 1 && ((permissions[0] == consts.Permissions.SMASubmitPatientCareRecords) || (permissions[0] == consts.Permissions.SubmitPatientCareRecord) || (permissions[0] == ""))) {
                    if ((permissions[0] == consts.Permissions.SMASubmitPatientCareRecords) || (permissions[0] == consts.Permissions.SubmitPatientCareRecord)) {
                        setdisablePCR(false);
                    }
                }
                props.history.push('/');
            }
        }
        else{
            props.history.push('/');
        }
        
        dispatch(showNavbar(true));
    }, [])

    const makeBooking = (): void => {
        localStorage.setItem("SelectedLocation", "");
        props.history.push('/addbooking')
    }
    const makePatientCareRecord = (): void => {
        props.history.push('/patientCareRecord')
    }


    return (
        <React.Fragment>
            <MuiThemeProvider theme={themeDark}>
                <Paper className={classes.container}>
                    <div className={classes.bodyContainer}>
                        <div className={classes.body}>
                            <img src={homepageLogo} className={classes.logo} />
                            <h1 className={classes.title}>Welcome {authStore?.data?.givenName}.</h1>
                            <h5 className={classes.subTitle}>Your last login was {formatDistanceToNowStrict(new Date(lastLogin || 0))} ago</h5>
                            <Typography  className={classes.subTitle2}>Our platform is designed to make it even easier to manage your patient transport schedule 
                            and work with our teams. We're always working on new features, so stay tuned!</Typography>
                            
                            {!disableBooking &&
                            <Button onClick={makeBooking} variant="contained" className={classes.button}>
                                Make A Booking
                            </Button>}
                            {!disablePCR &&
                            <Button onClick={makePatientCareRecord} variant="contained" className={classes.button}>
                                Submit A Patient Care Record
                            </Button>}
                        </div>
                        <div className={classes.footer}>
                            <div className={classes.divider} style={{ width: 600, height: '1px', backgroundColor: '#FFFFFF20' }}></div>
                            <img style={{ marginBottom: 25 }} src={icons} />
                            <div style={{ fontSize: 16, color: '#FFFFFF75' }}>For user support, please call our friendly team on <Link className={classes.link} href="tel:1300304063">1300 30 40 63</Link> or email us at <Link className={classes.link} href="mailto:support@statemedicalassistance.com.au">support@statemedicalassistance.com.au</Link></div>
                        </div>
                    </div>
                </Paper>
            </MuiThemeProvider>
        </React.Fragment>
    );
}

export default React.memo(withRouter(HomePage)) 
